import siteMessage from "@insite/client-framework/SiteMessage";

const getRequiredFieldMessage = (fieldLabel: string) => {
    return fieldLabel ? siteMessage("Field_Required", fieldLabel).toString() : "";
};

export default getRequiredFieldMessage;
